import React from 'react';

const About = () => {
  return (
    <div className="container" style={{ textAlign: 'left', lineHeight: '1.8', padding: '20px' }}>
      <h2>안녕하세요! 'Wellness Lab: 마음 건강 연구소'에 오신 것을 환영합니다.</h2>
      <p>
        'Wellness Lab'은 현대인의 지친 몸과 마음을 돌보고, 더 나은 삶의 질을 추구하는 분들을 위한 정보 공유 공간입니다.
      </p>
      <p>
        빠르게 변하는 세상 속에서 우리는 종종 자신의 건강과 마음 상태를 놓치곤 합니다. 저희 연구소는 누구나 쉽게 자신의 심리적 성향을 파악해 볼 수 있는 간단한 테스트와 함께, 일상에서 즉시 실천할 수 있는 과학적이고 유용한 건강 정보를 제공합니다.
      </p>
      <p>
        <strong>저희가 제공하는 가치:</strong>
      </p>
      <ul>
        <li><strong>맞춤형 성향 테스트:</strong> 스트레스 관리 유형 등 자아 발견을 돕는 다양한 콘텐츠를 제공합니다.</li>
        <li><strong>실질적인 웰니스 가이드:</strong> 혈당 관리, 도파민 디톡스, 수면 위생 등 최신 건강 트렌드를 심도 있게 다룹니다.</li>
        <li><strong>심리적 안정:</strong> 바쁜 일상 속에서 잠시 멈추고 자신을 돌아볼 수 있는 따뜻한 통찰을 나눕니다.</li>
      </ul>
      <p>
        에드센스 통과를 위한 단순한 사이트가 아닌, 방문해주시는 모든 분이 실질적인 도움을 얻어갈 수 있는 진정성 있는 플랫폼이 되도록 노력하겠습니다.
      </p>
      <p>
        감사합니다.
      </p>
    </div>
  );
};

export default About;